<template>
	<ContractListOnline :clientId="tiers.tiers_id" />
</template>

<script type="text/javascript">
	export default {
		name: "ContratTiersList",
		props: ['tiers'],
		components: {
			ContractListOnline: () => import('@/components/Contract/ContractListOnline')
		}
	}
</script>
